import { defineMessages } from 'react-intl';

export const messages: {
	frameLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	frameLabel: {
		id: 'company-hub.carousel-extension.card-strip.card.label',
		defaultMessage: 'slide {positionInSet} of {setSize}',
		description: 'Accessibility label text that is used for each card in the card strip',
	},
});
